export const FinalCta = () => {
  return (
    <section data-testid="final-cta-section" className="py-20 px-6 max-w-4xl mx-auto text-center">
      <div className="border border-[var(--ink)] p-10 sm:p-14 bg-[var(--card-bg)] relative">
        <span className="label-caps text-[10px] text-[var(--ink)]/60">
          Secure Stripe Checkout
        </span>
        <h2 className="serif-head text-3xl sm:text-5xl text-[var(--ink)] mt-3 mb-4">
          Express Yourself Naturally.
        </h2>
        <p className="text-xs sm:text-sm text-[var(--ink)]/75 max-w-md mx-auto font-light leading-relaxed mb-8">
          Select your preferred scent from our Canadian workshop. Hydrating skin spray infused
          with natural pheromone synergy.
        </p>
        <a
          href="#scents"
          data-testid="final-order-cta"
          className="inline-block border border-[var(--ink)] bg-[var(--ink)] text-[var(--bg)] px-8 py-3.5 label-caps text-[11px] hover:bg-transparent hover:text-[var(--ink)] transition-colors"
        >
          Order Spray &bull; $68
        </a>
      </div>
    </section>
  );
};
